<template>
    <b-modal size="md" centered hide-header hide-footer body-class="p-0" ref="notification-data">
        <DevicesNotification ref="devices-notification" @save-devices="handleDeviceSave"></DevicesNotification>
        <DrawGeofence ref="draw-geofence" @save-area="handleSaveArea"></DrawGeofence>
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <img src="@/assets/img/geofences.svg">
                <p class="text-light m-0 fs-4 ms-2">{{ title }}</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg">
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <b-form-group label="Nombre:" label-for="name">
                <b-form-input id="name" v-model="name" class="mb-2" placeholder="Ejm: Casa de Campo" trim></b-form-input>
            </b-form-group>
            <b-form-group label="Descripción:" label-for="description">
                <b-form-input id="description" v-model="description" class="mb-2" placeholder="Ejm: Vacaciones en Familia" trim></b-form-input>
            </b-form-group>
            <b-form-group label="Icono:" class="mb-2">
                <img class="selected-icon" :src="require(`@/assets/img/geofences/${icon}.png`)">
            </b-form-group>
            <div class="icons-box p-3 d-flex flex-row flex-wrap border mb-2 justify-content-center">
                <img class="option-icon" :src="require(`@/assets/img/geofences/${index - 1}.png`)" v-for="(index) in 19" :key="index" @click="setIcon(index - 1)">
            </div>
            <button type="button" class="btn btn-outline-primary mb-2" @click="showDevices">Agregar Unidades ({{ assignedDevices }})</button>
            <button type="button" class="btn btn-outline-primary mb-2" @click="showDrawGeofence">Dibujar Geocerca</button>
            <b-button variant="primary" @click="saveGeofence">Guardar</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import GeofenceService from '@/api/services/geofence.service';
import PermissionsService from '@/api/services/permissions.service';
import notificationsModule from '@/store/modules/notifications.module';
import { Component, Vue } from 'vue-property-decorator';
import DevicesNotification from '@/components/modals/DevicesNotification.vue';
import DrawGeofence from './DrawGeofence.vue';
import geofencesModule from '@/store/modules/geofences.module';
@Component({ components: { DevicesNotification, DrawGeofence } })
export default class GeofenceData extends Vue {
    name = ''
    icon = '1'
    area = ''
    description = ''

    assignedDevices = 0
    title = 'Crear Geocerca'

    devicesId: number[] = []

    close() {
        const modal: any = this.$refs['notification-data']
        modal.hide();
        this.name = ''
        this.assignedDevices = 0
        this.devicesId = []
    }

    show() {
        const modal: any = this.$refs['notification-data']
        modal.show();
    }

    setIcon(iconId: number) {
        this.icon = iconId.toString()
    }

    async saveGeofence() {
        const res = await GeofenceService.create({
            name: this.name,
            area: this.area,
            attributes: {
                icon: this.icon
            },
            description: this.description
        })
        geofencesModule.addGeofence(res.data)
        const notificationId = res.data?.id
        await Promise.all(this.devicesId.map(deviceId => {
            return PermissionsService.assignGeofence(deviceId, notificationId)
        }))
        this.close()
    }

    showDevices() {
        const modal: any = this.$refs['devices-notification']
        modal.show();
    }

    showDrawGeofence() {
        const modal: any = this.$refs['draw-geofence']
        modal.show();
    }

    handleDeviceSave(selectedDeviceIds: number[]) {
        this.devicesId = selectedDeviceIds
        this.assignedDevices = selectedDeviceIds.length
    }

    handleSaveArea(area: string) {
        this.area = area
    }
    
}
</script>

<style lang="sass" scoped>
    @import '@/assets/style/variables.sass'
    @import '@/assets/style/modal-styles.sass'

    div
        font-family: 'Changa', sans-serif !important
    .form-check-label
        gap: 5px
        cursor: pointer
    .list-group
        overflow: auto !important
        max-height: 30vh !important
    .list-group-item
        p
            line-height: 20px
        img
            height: 30px

    .selected-icon
        height: 40px
    .option-icon
        height: 35px
        transition: all .1s ease
        cursor: pointer
        &:hover
            transform: scale(1.1)
        &:active
            transform: scale(.9)
    .icons-box
        gap: 10px

    select
        cursor: pointer
    
    .badge
        align-self: end

    .badge, .delete
        cursor: pointer
        transition: all .1s ease
        &:active
            transform: scale(.9)
</style>